import axiosInstance from "../axiosInstance";

export const historicalInventoryService = {
  fetch: async (query = "", signal) => {
    try {
      let api = `/historical-inventory?`;

      if (!query.includes("$sort")) {
        api += `&$sort[date]=-1`;
      }

      if (query && query.length) api += `&${query}`;

      const response = await axiosInstance.get(
        api,
        signal ? { signal } : undefined,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post("/historical-inventory", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (id, data) => {
    try {
      const response = await axiosInstance.patch(
        `/historical-inventory/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/historical-inventory/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
